import ConfigProvider from 'antd/es/config-provider';
import React from 'react';

import { ButtonHtmlType } from '@/enums';

import * as Style from './FilledButton.style';

interface Props {
  children: React.ReactNode;
  htmlType?: ButtonHtmlType;
  loading?: boolean;
  disabled?: boolean;
  height?: string;
  width?: string;
  fontSize?: string;
  onClick?: () => void;
  className?: string;
  gradient?: string;
}

const FilledButton = ({
  children,
  htmlType = ButtonHtmlType.Button,
  ...rest
}: Props) => {
  return (
    <ConfigProvider
      theme={{
        cssVar: true,
        hashed: false,
        token: {
          colorSplit: '#64895b',
        },
        components: {
          Button: {
            defaultBg: '#64895b',
            defaultBorderColor: '#64895b',
            defaultColor: '#ffffff',
            defaultHoverColor: '#64895b',
            defaultHoverBg: '#ffffff',
            defaultHoverBorderColor: '#ffffff',
            defaultActiveBg: '#ffffff',
            defaultActiveBorderColor: '#ffffff',
            defaultActiveColor: '#64895b',
          },
        },
      }}
    >
      <Style.FilledButton
        variant="filled"
        shape="round"
        autoInsertSpace={false}
        htmlType={htmlType}
        {...rest}
      >
        <Style.FilledButtonText ellipsis={{ rows: 1 }} className="button-text">
          {children}
        </Style.FilledButtonText>
      </Style.FilledButton>
    </ConfigProvider>
  );
};

export default FilledButton;
